import React from 'react';
import PropTypes from 'prop-types';
import RateGridAccorindon from './rateGridAccorindon';
import { Accordion, Icon } from '@weezevent/nacre';
/**
 * Component to manage Rate in Group
 * @param {object} event: event object to have id event
 * @param {object} group: object group
 * @param {object} discountForm: discountForm object form discount
 * @param {func} handleDiscountChange: handleDiscountChange fun to set form
 */
export default function GroupRate({ group, event, handleDiscountChange, discountForm, openByDefault, openAllAccorindon }) {
    const nestedGroups = (group.children || []).map((group, index) => {
        return (
            <GroupRate
                openByDefault={openAllAccorindon || (!group.rates.length && index === 0)}
                key={`${openAllAccorindon}-${group.id}`}
                group={group}
                event={event}
                handleDiscountChange={handleDiscountChange}
                discountForm={discountForm}
                openAllAccorindon={openAllAccorindon}
            />
        );
    });

    return (
        <Accordion
            classname={null}
            disableToggle={false}
            openByDefault={openByDefault}
            title={
                <>
                    <Icon name="folder-closed" /> {group.name}
                </>
            }
        >
            {group.rates.map((rate, i) => (
                <RateGridAccorindon
                    event={event}
                    openByDefault={openAllAccorindon || (openByDefault && i === 0)}
                    rate={rate}
                    index={rate.id}
                    key={rate.id}
                    handleDiscountChange={handleDiscountChange}
                    discountForm={discountForm}
                />
            ))}
            {nestedGroups}
        </Accordion>
    );
}

GroupRate.propTypes = {
    group: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    handleDiscountChange: PropTypes.func.isRequired,
    discountForm: PropTypes.object.isRequired,
    openAllAccorindon: PropTypes.bool
};
